import baseAPI from '@/api/base';
import { EditUser, GetUser, RegisterUser } from '@/dtos/user.dto';
import {
  DELETE_USER_URL,
  EDIT_USER_URL,
  GET_USER_URL,
  REGISTER_USER_URL,
  TOGGLE_USER_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class User {
  static getUsers = async (getUser: GetUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_USER_URL, {
      params: getUser,
    });
    console.log('response', response);
    return response;
  };

  static registerUser = async (
    registerUser: RegisterUser
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_USER_URL, {
      ...registerUser,
    });
    console.log('response', response);
    return response;
  };

  static editUser = async (editUser: EditUser): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_USER_URL, {
      ...editUser,
    });
    return response;
  };

  static toggleUserIsActive = async (
    editUser: EditUser
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_USER_IS_ACTIVE_URL,
      {
        ...editUser,
      }
    );
    return response;
  };

  static deleteUser = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_USER_URL}/${id}`
    );
    return response;
  };
}

export default User;
